import {RootState} from "../../common/store";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {MultiPolygon, Polygon} from "geojson";

export interface DrawPolygonState {
  active: boolean,
  geometry?: Polygon | MultiPolygon
}


const initialState: DrawPolygonState = {
  active: false
}

export const AP_DRAW_MODE = 'apDrawMode'

export const apDrawModeSlice = createSlice({
  name: 'apDrawMode',
  initialState,
  reducers: {
    updateDrawMode: (state: DrawPolygonState, action: PayloadAction<DrawPolygonState>) => {
      state.active = action.payload.active
      state.geometry = action.payload.geometry
    }
  }
})

export const {
  updateDrawMode,
} = apDrawModeSlice.actions

export const selectDrawModeState = (state: RootState) => {
  return state[AP_DRAW_MODE].active
}
export const selectDrawnPolygon = (state: RootState) => {
  return state[AP_DRAW_MODE].geometry
}
